export default __webpack_public_path__ + "9cf77533b7aafd421427dc64154b2a3b.svg";